import { currencyTypes } from "../constants/CompanyCurrencyType";
import { useAuthStore } from "../store";

export function formatCurrency(num: number, format: string) {
  let returnFormat = "INR";
  for (const [key, value] of Object.entries(currencyTypes)) {
    if (value.toString() === format) {
      returnFormat = key.toString();
    }
  }
  if (returnFormat === "SGD") {
    return `${"S$"}${num?.toLocaleString(format)}`;
  } else {
    return num?.toLocaleString(format, {
      style: "currency",
      currency: returnFormat,
    });
  }
}

export function getCurrencyType() {
  const { user } = useAuthStore();
  const res = user?.company.companyCurrency.split("-")[0].trim() || "INR";
  const key = res as keyof typeof currencyTypes;
  const currencyType =
    key != null ? currencyTypes[key] : window.navigator.language;
  return currencyType;
}

export function getCurrencySymbol() {
  const { user } = useAuthStore();
  const res = user?.company.companyCurrency.split("-")[1].trim() || "";
  return res;
}
